export default "__VITE_ASSET__fnUdItvz__"